import Vue from 'vue'
import Rollbar from 'rollbar'

const createRollbarInstance = function (accessToken) {
  const config = {"enabled":true,"captureUncaught":false,"captureUnhandledRejections":false,"payload":{"environment":"production"}}
  config.accessToken = accessToken
  return new Rollbar(config)
}

const serverRollbar = createRollbarInstance('2DCQlEWC1wAjXGXHU0oCLOhqqQP')

const clientRollbar = createRollbarInstance('314ff8239a75444f9e179d221e0ed947')

const noop = function () {}
const stubRollbar = Object.create(null)
Object.defineProperties(
  stubRollbar,
  Object.getOwnPropertyNames(Rollbar.prototype).reduce(function (acc, key) {
    acc[key] = { value: noop }
    return acc
  }, {}))

const RollbarAdapter = Object.create(null)
Object.defineProperty(RollbarAdapter, 'instance', {
  get() {
    if (process.server) {
      return serverRollbar
    }

    if (process.client) {
      return clientRollbar
    }

    return stubRollbar
  },
})

export default function (ctx, inject) {
  // Inject Rollbar to the context as $rollbar
  ctx.$rollbar = RollbarAdapter.instance
  inject('rollbar', RollbarAdapter.instance)
  Vue.rollbar = RollbarAdapter.instance
}
